import { useRouter } from 'next/router';

/**
 * Returns the current workspace ID
 */
export default function useWorkspaceID(): string {
  const router = useRouter();
  const workspaceID = router.query.workspace;
  if (!router.isReady) return '';

  if (!workspaceID) {
    throw new Error('useWorkspaceID can only be used in the context of a workspace');
  } else if (Array.isArray(workspaceID)) {
    throw new Error(
      'There should only be a single workspace ID in the URL, i.e. workspace=__ and not workspace=__&workspace=__',
    );
  } else {
    return workspaceID;
  }
}

// export default function useWorkspaceID(): string {
//     const router = useRouter();
//     let workspaceID = router.query.workspace;

//     if (!workspaceID && typeof window !== "undefined") {
//         // Because useRouter is a hook router.query isn't populated until after the first render (WHICH IS STUPID). This
//         // grabs the workspace ID from the pathname if it's available.
//         workspaceID = window.location.pathname.split("/")[1];

//         if (!workspaceID) {
//             throw new Error("useWorkspaceID can only be used in the context of a workspace");
//         } else return workspaceID;
//     } else if (Array.isArray(workspaceID)) {
//         throw new Error(
//             "There should only be a single workspace ID in the URL, i.e. workspace=__ and not workspace=__&workspace=__"
//         );
//     } else {
//         return workspaceID ?? "";
//     }
// }
